import { COLOR_KEYS } from '../../../constants';
import { SectionName, withTracking } from '../../../observability';
import { createBuilderModule } from '../../../register-builder/builder-module';
import { DEFAULT_VALUES } from './fixtures';
import { ScrollingTweetsSection } from './ScrollingTweetsSection';

export default createBuilderModule(
  withTracking(ScrollingTweetsSection, {
    as: 'section',
    sectionName: SectionName.ScrollingTweetsSection,
  }),
  {
    name: 'ScrollingTweetsSection',
    image: 'https://cdn.zappy.app/9672290cb2a53fb77db379e85a96089f.svg',
    inputs: [
      {
        name: 'heading',
        type: 'string',
        required: true,
        defaultValue: DEFAULT_VALUES.heading,
      },
      {
        name: 'tweets',
        type: 'list',
        required: true,
        subFields: [
          {
            name: 'name',
            type: 'string',
            required: true,
          },
          {
            name: 'handle',
            type: 'string',
            required: true,
          },
          {
            name: 'body',
            type: 'richText',
            required: true,
          },
          {
            name: 'avatarUrl',
            type: 'string',
          },
          {
            name: 'mediaUrl',
            type: 'cloudinaryImage',
          },
          {
            name: 'mediaAltText',
            type: 'string',
          },
          {
            name: 'url',
            type: 'string',
          },
        ],
        defaultValue: DEFAULT_VALUES.tweets,
      },
      {
        name: 'backgroundColor',
        type: 'string',
        enum: [
          COLOR_KEYS.bolt,
          COLOR_KEYS.peach,
          COLOR_KEYS.blue10,
          COLOR_KEYS.neutral100,
        ],
        required: true,
        defaultValue: DEFAULT_VALUES.backgroundColor,
      },
    ],
  },
);
